var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sink-handler',[_c('div',{staticClass:"not-found-container"},[_c('div',{staticClass:"flex-container"},[_c('div',{staticClass:"description"},[_c('p',{staticClass:"not-found"},[_vm._v("404")]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("Page non trouvée, veuillez contactez un administrateur.")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-607ec19d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/page/NotFound/Index.vue
// module id = eaf0
// module chunks = 1